/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_Errors_Invalid_TokenInputs */

const nl_auth_password_errors_invalid_token = /** @type {(inputs: Auth_Password_Errors_Invalid_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeldige token`)
};

/**

* @param {Auth_Password_Errors_Invalid_TokenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_password_errors_invalid_token = /** @type {((inputs?: Auth_Password_Errors_Invalid_TokenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_Errors_Invalid_TokenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_password_errors_invalid_token(inputs)
});
export { auth_password_errors_invalid_token as "auth.password_errors.invalid_token" }